var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5931 14.6328C16.5931 14.1024 16.8038 13.5937 17.1789 13.2186C17.554 12.8435 18.0627 12.6328 18.5931 12.6328H34.5931C35.1235 12.6328 35.6322 12.8435 36.0073 13.2186C36.3824 13.5937 36.5931 14.1024 36.5931 14.6328V30.6328C36.5931 31.1632 36.3824 31.672 36.0073 32.047C35.6322 32.4221 35.1235 32.6328 34.5931 32.6328C34.0627 32.6328 33.554 32.4221 33.1789 32.047C32.8038 31.672 32.5931 31.1632 32.5931 30.6328V19.4608L16.0071 36.0468C15.6299 36.4111 15.1247 36.6127 14.6003 36.6082C14.0759 36.6036 13.5743 36.3933 13.2035 36.0224C12.8326 35.6516 12.6223 35.15 12.6178 34.6256C12.6132 34.1012 12.8148 33.596 13.1791 33.2188L29.7651 16.6328H18.5931C18.0627 16.6328 17.554 16.4221 17.1789 16.047C16.8038 15.672 16.5931 15.1632 16.5931 14.6328Z",
    fill: "#6C6CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleArrow);
export default __webpack_public_path__ + "static/media/angle-arrow.f7b0beff35d8f23c44f8817f93d44d8e.svg";
export { ForwardRef as ReactComponent };